/**
 * Rest swr cache keys
 */
export enum restKeys {
    getCurrencies = 'getCurrencies',
    getSymbols = 'getSymbols',
    getSwapCurrencies = 'getSwapCurrencies',
    getSwapFeatures = 'getSwapFeatures',
    getStakingUser = 'getStakingUser',
    getStakingCurrencies = 'getStakingCurrencies',
    getUserInfo = 'getUserInfo',
    getReferralLinks = 'getReferralLinks',
    getReferralBalance = 'getReferralBalance',
    getProvider = 'getProvider',
    getCommonCMSConfig = 'getCommonCMSConfig',
    getMarketPageConfig = 'getMarketPageConfig',
    getReceiveFiatList = 'getReceiveFiatList',
    getSendFiatList = 'getSendFiatList',
    getTransactionsHistory = 'getTransactionsHistory',
    getTotps = 'getTotps',
    generateTotp = 'generateTotp',
    getVerificationLevels = 'getVerificationLevels',
    getAccountUserInfo = 'getAccountUserInfo',
    getKycUserInfo = 'getKycUserInfo',
    getAssetLimits = 'getAssetLimits',
    getTransferConvertConfig = 'getTransferConvertConfig',
    isPermalinkSet = 'isPermalinkSet',
    getUserAppSettings = 'getUserAppSettings',
    getMigrationStatus = 'getMigrationStatus',
    getKycRequestStatus = 'getKycRequestStatus',
    getBoundAddressConfig = 'getBoundAddressConfig',
    getVcardsBalances = 'getVcardsBalances',
    getIDPsList = 'getIDPsList',
    getTickers = 'getTickers',
    getActiveSessions = 'getActiveSessions',
    getIban = 'getIban',
    getIbanStatuses = 'getIbanStatuses',
    getIbanInfo = 'getIbanInfo',
    getIbanCurrencies = 'getIbanCurrencies',
    prepareDepositCrypto = 'prepareDepositCrypto',
    getRates = 'getRates',
    getRatesBatch = 'getRatesBatch',
    getReceiveFiatConfig = 'getReceiveFiatConfig',
    getSendFiatConfig = 'getSendFiatConfig',
    getFiatWithdrawalMethods = 'getFiatWithdrawalMethods',
    getFiatTransferMethods = 'getFiatTransferMethods',
    getFiatTransferRequisiteValues = 'getFiatTransferRequisiteValues',
    getFiatTransferFees = 'getFiatTransferFees',
    walletBalances = 'walletBalances',
    spotBalances = 'spotBalances',
    getFiatTransferTransactionDetails = 'getFiatTransferTransactionDetails',
    estimateWithdrawalFees = 'estimateWithdrawalFees',
    getProducts = 'getProducts',
    getCards = 'getCards',
    getIssueForm = 'getIssueForm',
    cardsBalance = 'cardsBalance',
    getAgreements = 'getAgreements',
    getSensitiveDetails = 'getSensitiveDetails',
    getTransactionsCardsHistory = 'getTransactionsCardsHistory',
    getLocales = 'getLocales',
    getConfig = 'getConfig',
    getHomeButtonsConfig = 'getHomeButtonsConfig',
    getThreeDSChallenges = 'getThreeDSChallenges',
    getThreeDSConfig = 'getThreeDSConfig',
    getThreeDSMethods = 'getThreeDSMethods',
    getThreeDSQuestions = 'getThreeDSQuestions',
    getManualKycLevelsConfig = 'getManualKycLevelsConfig',
    getUserAuth = 'getUserAuth',
}

/**
 * Socket swr cache keys
 */
export enum socketKeys {
    getSpotTradingBalances = 'getSpotTradingBalances',
    getFuturesTradingBalances = 'getFuturesTradingBalances',
    getWalletBalances = 'getWalletBalances',
}
